import axios from 'axios';
import Settings from '../../../settings.json';

const url = Settings.isNative ? Settings.frontlineArServer : '';

export class RolePresetsRequester {
    static async getRolePresets(workspace) {
        const result = await axios.post(`${url}/RolePresetsManagement/${workspace}/GetRolePresets`);
        return result.data;
    }

    static async createRolePreset(workspace, initialValues = {}) {
        const result = await axios.post(`${url}/RolePresetsManagement/${workspace}/CreateRolePreset`, initialValues);
        return result.data;
    }

    static async editRolePreset(workspace, {rolePresetId, updates, applyToMembers = false}) {
        const result = await axios.post(`${url}/RolePresetsManagement/${workspace}/EditRolePreset`, {
            rolePresetId, updates, applyToMembers,
        });
        return result.data;
    }

    static async deleteRolePreset(workspace, rolePresetId) {
        const result = await axios.post(`${url}/RolePresetsManagement/${workspace}/DeleteRolePreset`, {rolePresetId});
        return result.data;
    }

    static async getRolePresetMembers(workspace, rolePresetId) {
        const result = await axios.post(`${url}/RolePresetsManagement/${workspace}/GetRolePresetMembers`, {rolePresetId});
        return result.data;
    }

    static async reassignMembers(workspace, {fromPresetId, toPresetId, memberIds}) {
        const result = await axios.post(`${url}/RolePresetsManagement/${workspace}/ReassignMembers`, {fromPresetId, toPresetId, memberIds});
        return result.data;
    }
}
